export default __webpack_public_path__ + "images/3be9ff006f6b981293e74e68a1800344-EE_SlideDeckBOOK1024_7.png";